<template>
  <res-select class="group-type-selector" v-model="selectedGroupType" :items="groupTypes" attach=".group-type-selector" :filled="filled" :readonly="readonly" :loading="loading" return-object></res-select>
</template>

<script>
  import ResSelect from '@/components/base/ResSelect.vue';
  import groupTypeService from '@/services/group-type';

  export default {
    name: 'groupTypeSelector',
    components: {
      ResSelect
    },
    data() {
      return {
        groupTypes: [],
        loading: true,
      }
    },
    props: {
      value: {
        required: true
      },
      filled: {},
      readonly: {},
    },
    computed: {
      selectedGroupType: {
        get () {
          return this.value
        },
        set(newValue) {
          this.$emit("input", newValue)
        }
      }
    },
    async mounted() {
      let groupTypeData = await groupTypeService.getDropdown();
      if (groupTypeData && groupTypeData.data) {
        this.groupTypes = groupTypeData.data;
      } else {
        this.groupTypes = [];
      }
      this.loading = false;
    }
  }
</script>
